import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03b0e159"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "avatar d-flex justify-content-center flex-column align-items-center" }
const _hoisted_8 = { class: "avatar-info rounded-full mt-3" }
const _hoisted_9 = { class: "mt-2 ms-2" }
const _hoisted_10 = { class: "fs-7" }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = { class: "d-flex justify-content-center" }

import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import Matter from './components/Matter.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'

import { translate } from '@/languages/i18n'
import { COMMUNITY_CHAT_LIST_STORE } from '@/store/constants'
import Avatar from '@/components/avatar/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const profile = computed(() => store.getters[COMMUNITY_CHAT_LIST_STORE.GETTERS.CHAT_LIST_HISTORIES]?.profile)
// const loading = computed(() => store.getters[COMMUNITY_CHAT_LIST_STORE.GETTERS.CHAT_LIST_HISTORIES]?.loading)
const loading = ref(false)
const directChatroomId = computed(() => store.getters[COMMUNITY_CHAT_LIST_STORE.GETTERS.CHAT_LIST_HISTORIES]?.direct_chatroom_id)

onMounted(async () => {
  loading.value = true
  await store.dispatch(COMMUNITY_CHAT_LIST_STORE.ACTIONS.SET_CHAT_LIST_HISTORIES, {
    id: route.params?.id,
    params: {
      management_no: route.params?.managementNo,
      page: route.query?.page || 1,
      page_of_number: route.query?.page_of_number || 30,
    },
  })
  loading.value = false
})

const breadcrumb = [
  { content: translate('CC10home'), to: `/community/communities/${route.params?.id}/dashboard`, active: false },
  {
    content: translate('OE30userManagement'),
    to: '',
    active: false,
  },
  {
    content: `${translate('OE10listUser')}（${translate(route.path.split('/').includes('alumnus') ? 'almunai' : 'CD40enrolledUser')}）`,
    to: `/community/communities/${route.params?.id}/${route.path.split('/').includes('alumnus') ? 'alumnus' : 'community-users'}?management_no=desc`,
    active: false,
  },
  { content: translate('chatList'), to: '', active: true },
]

const transitOE75 = (): void => {
  if (directChatroomId.value)
    router.push(
      route.path.split('/')[1] === 'community'
        ? `/${route.path.split('/')[1]}/communities/${route.params?.id}/admin/direct_chat/${directChatroomId.value}`
        : `/${route.path.split('/')[1]}/communities/${route.params?.id}/direct_chat/${directChatroomId.value}`
    )
}

const ReplayName = (is_deleted_in_30_days: string | number, available: boolean, family_name: string, given_name: string, user_type, display_name: string) => {
  if (!is_deleted_in_30_days) {
    if (!available) {
      if ([2, 'alumni'].includes(user_type) && display_name) {
        return family_name + ' ' + given_name + ' ' + '[一時停止]' + `（${display_name}）`
      }
      return family_name + ' ' + given_name + ' ' + '[一時停止]'
    } else {
      if ([2, 'alumni'].includes(user_type) && display_name) {
        return family_name + ' ' + given_name + ' ' + `（${display_name}）`
      }
      return family_name + ' ' + given_name
    }
  } else if (is_deleted_in_30_days === 1) {
    if ([2, 'alumni'].includes(user_type) && display_name) {
      return family_name + ' ' + given_name + ' ' + '[脱退済み]' + `（${display_name}）`
    }
    return family_name + ' ' + given_name + ' ' + '[脱退済み]'
  } else if (is_deleted_in_30_days === 2) {
    return '脱退済みユーザ'
  } else {
    if ([2, 'alumni'].includes(user_type) && display_name) {
      return family_name + ' ' + given_name + ' ' + `（${display_name}）`
    }
    return family_name + ' ' + given_name
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('chatList')), 1),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Avatar, {
                  is_deleted_in_30_days: _unref(profile)?.is_deleted_in_30_days,
                  user_image_url: _unref(profile)?.image_url,
                  userType: _unref(profile)?.user_type
                }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(UserAliasIcon, {
                  userType: _unref(profile)?.user_type
                }, null, 8, ["userType"])
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(translate)('managementNo')) + "." + _toDisplayString(_unref(profile)?.management_no), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(ReplayName(_unref(profile)?.is_deleted_in_30_days, _unref(profile)?.available, _unref(profile).family_name, _unref(profile)?.given_name, _unref(profile)?.user_type, _unref(profile)?.display_name)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(Button, {
                title: _unref(translate)('chatTitle'),
                type: 'secondary',
                disabled: !_unref(profile)?.available || [1, 2].includes(_unref(profile)?.is_deleted_in_30_days),
                className: 'my-4',
                onClick: transitOE75
              }, null, 8, ["title", "disabled"])
            ]),
            _createVNode(Matter)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})